import script from "./CustomSignIn.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomSignIn.vue?vue&type=script&setup=true&lang=js"

import "./CustomSignIn.vue?vue&type=style&index=0&id=e4578356&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4578356"]])

export default __exports__